import { FC } from "react";
import useTranslate from "hooks/useTranslate";
import LoyaltyTagStatusRank from "components/atoms/LoyaltyTagStatusRank";
import { LoyaltyTagStatusVariantT } from "components/atoms/LoyaltyTagStatusRank/types";
import ArrowIcon from "assets/icons/arrow.svg?react";
import "./styles.sass";

type LoyaltyLevelRewardButtonProps = {
  rankName: string;
  handleClick: () => void;
  status?: LoyaltyTagStatusVariantT;
  image?: string;
};

const LoyaltyLevelRewardButton: FC<LoyaltyLevelRewardButtonProps> = (props) => {
  const { rankName, handleClick, image, status = "nextRank" } = props;
  const t = useTranslate();

  return (
    <button
      className="LoyaltyLevelRewardButton"
      onClick={handleClick}
      type="button"
    >
      <div className="LoyaltyLevelRewardButton__info">
        <LoyaltyTagStatusRank status={status} />
        <span className="LoyaltyLevelRewardButton__name">
          {t(rankName)}{" "}
          <ArrowIcon className="LoyaltyLevelRewardButton__arrow" />
        </span>
      </div>
      <img src={image} alt="rank-image" />
    </button>
  );
};

export default LoyaltyLevelRewardButton;
